// regex rules "\s-.()" and "{9,}" count the leading & trailing special characters
// so 9 in "{9,}" offsets by 2 leading and trailing special characters to match at least 7 digit numeric characters in string
// See travelBotDataMask.spec for unit tests
var MASK_REG_EXP = /[0-9\s-.()]{9,}/gim;
export function maskNumbersInMessage(message) {
    var maskNumbersInString = function (match) {
        var trimmedMatch = match.trim();
        var maskedMessage = new Array(trimmedMatch.length + 1).join('X');
        var matchedMessage = message.match(trimmedMatch);
        var nextCharAfterMatch = matchedMessage &&
            matchedMessage.index &&
            message.charAt(matchedMessage.index + trimmedMatch.length);
        var leadingSpace = ' ';
        var trailingSpace = nextCharAfterMatch === ',' || nextCharAfterMatch === ';' || nextCharAfterMatch === ':' ? '' : ' ';
        return leadingSpace + maskedMessage + trailingSpace;
    };
    return message.replace(MASK_REG_EXP, maskNumbersInString);
}
//# sourceMappingURL=travelBotDataMask.js.map